import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DocumentService } from './../services/document.service';
import { AppConfig } from './../config/app-config';
import { FileSection, FileType, FileData } from './../models/fileData';
import { ToastService } from './../services/toast.service';
import { SafeHtml, DomSanitizer, Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { from, Observable } from 'rxjs';
import { Location } from "@angular/common";


@Component({
  selector: 'app-document-library',
  templateUrl: './document-library.component.html'
})
export class DocumentLibraryComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private documentService: DocumentService,
    public toastService: ToastService,
    private titleService: Title,
    private appConfig: AppConfig,
    private router: Router) { }

  page = 1;
  pageSize = 12;
  collectionSize = 0;

  AllDocuments: any[] = [];
  DocumentCategories$: any[] = [];
  Documents$: any[] = [];

  textFilter: string = "";
  categoryFilter: any[] = [];

  featuredDoc = null;

  selectAnnualReport: boolean = false;
  //selectedCategoryId = 0;
  selectedCategoryId = 0;
  categoryName = "";

  getDocumentCategoriesList() {
    this.documentService.getDocumentsCategoriesList().subscribe((response) => {
      //this.DocumentCategories$ = response as any[];
      this.DocumentCategories$ = response.sort((a, b) => (a.title.trim() > b.title.trim()) ? 1 : ((b.title.trim() > a.title.trim()) ? -1 : 0)) as any[];
      //console.log(this.DocumentCategories$);
    }, (error) => {
      console.error(error);
    });
  }

  getDocumentsList() {
    this.documentService.getDocumentsList().subscribe((response) => {

      this.AllDocuments = response.sort((a, b) => (b.docDate > a.docDate) ? 1 : ((a.docDate > b.docDate) ? -1 : 0)) as any[];
      //response as any[];
      this.Documents$ = this.AllDocuments;
      this.collectionSize = this.Documents$.length;

      this.setFeaturedDoc();

      //this.highlightAnnualReport();
      this.highlightCategory('annualReport', 'CDC Annual Reports');
      this.highlightCategory('sezIncentives', 'SEZ Incentives');
      this.highlightCategoryId('showCategory');
      //
      return this.AllDocuments
        .map((doc, i) => ({ id: i + 1, ...doc }))
        .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    }, (error) => {
      console.error(error);
    });
    return null;
  }

  downloadFile(linkedId: number) {
    //const fileInfo =
    $("#file" + linkedId.toString()).html('Downloading&nbsp;&nbsp;&nbsp; <i class=\'fas fa-spinner fa-spin ml-2\'></i>');
    $("#file" + linkedId.toString()).addClass("disabled");
    this.documentService.getFileInfo(linkedId).subscribe((response) => {

      const fileInfo = response[0];

      fileInfo.fileLocation = this.appConfig.baseUrl + '/Uploads/' + FileSection[fileInfo.fileSection] + '/' + FileType[fileInfo.fileType] + '/' + fileInfo.linkedId + '/' + fileInfo.physicalFileName;

      this.documentService.downloadFile(fileInfo.fileLocation).subscribe((fileResponse) => {
        // file-type
        //const fileName = fileInfo.displayFileName;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(fileResponse.body);

        window.open(link.href, "_blank");
        //console.clear();
        //console.log(fileResponse);
        $("#file" + linkedId.toString()).html('DOWNLOAD <b>NOW&nbsp;</b> <i class="fas fa-chevron-right"></i>');
        $("#file" + linkedId.toString()).removeClass("disabled");
      }, (error) => {
        console.error(error);
        $("#file" + linkedId.toString()).html('DOWNLOAD <b>NOW&nbsp;</b> <i class="fas fa-chevron-right"></i>');
        $("#file" + linkedId.toString()).removeClass("disabled");

        this.toastService.show('DOCUMENT ERROR. The document link is currently unavailable', { classname: 'bg-danger text-light', delay: 7500, autohide: true });
      });

      return fileInfo;
    }, (error) => {
      console.error(error);
    });
  }

  setFeaturedDoc() {
    this.featuredDoc = this.AllDocuments.find(x => x.featuredDoc === true);
  }

  filterCategories(event) {
    if (event.checked === true) {

      const exists = this.categoryFilter.some(f => f == event.value);

      if (exists === false) {
        this.categoryFilter.push(event.value);
      }
    }
    else {
      const index = this.categoryFilter.indexOf(event.value, 0);
      if (index > -1) {
        this.categoryFilter = this.categoryFilter.filter(a => a !== event.value)
      }
    }

  }

  filterCategoriesLink(linkId) {
    console.info("Filter Cat: " + linkId)
    this.selectedCategoryId = linkId;
    this.categoryFilter = [];
    if (linkId > 0)
      this.categoryFilter.push(linkId);
    //this.applyFilters();
    this.applyFiltersNew();
    window.scroll(0, 0);
  }

  filterCategoriesLinkNew(linkId) {
    console.info("Filter Cat: " + linkId)
    this.selectedCategoryId = linkId;
    this.categoryFilter = [];
    if (linkId > 0) {
      this.categoryFilter.push(linkId);
      this.SetQueryParams(linkId);
    }
    this.applyFiltersNew();
    window.scroll(0, 0);
  }

  SetQueryParams(linkId) {

    const queryParams: Params = { id: linkId };

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: "merge"
    })

  }

  applyFilters() {
    const filterText = this.textFilter.toLowerCase();

    if (filterText === '' && this.categoryFilter.length === 0) {
      this.Documents$ = this.AllDocuments;
    }
    else {
      this.Documents$ = [];

      const result = [];

      if (this.textFilter.length > 0) {
        //text search
        result.push(this.AllDocuments.filter(x =>
          x.title.toLowerCase().includes(filterText) ||
          x.description.toLowerCase().includes(filterText) ||
          x.tags.toLowerCase().includes(filterText)
        ));
      }

      if (this.categoryFilter.length > 0) {
        //category search

        result.push(this.AllDocuments.filter(x =>
          this.categoryFilter.find(y => +y === +x.categoryId)
        ));

      }

      if (result.length > 0) {
        const final = [];
        //combine result into one final array
        result.forEach(function (val) {
          final.push(val);
        });
        //remove duplicates from final array
        const unique = final.filter(function (elem, index, self) {
          return index === self.indexOf(elem);
        });

        this.Documents$ = unique[0];
      }
    }

    if (this.Documents$.length == 0) {
      this.Documents$ = null;
      this.collectionSize = 0;
    }
    else {
      this.collectionSize = this.Documents$.length;
    }
  }

  applyFiltersNew() {
    $("#pnlCategories").hide();
    $("#pnlDocuments").show();
    const filterText = this.textFilter.toLowerCase();

    if (filterText === '' && this.categoryFilter.length === 0) {
      this.Documents$ = this.AllDocuments;
    }
    else {
      this.Documents$ = [];

      const result = [];

      if (this.textFilter.length > 0) {
        //text search
        result.push(this.AllDocuments.filter(x =>
          x.title.toLowerCase().includes(filterText) ||
          x.description.toLowerCase().includes(filterText) ||
          x.tags.toLowerCase().includes(filterText)
        ));
      }

      if (this.categoryFilter.length > 0) {
        //category search

        result.push(this.AllDocuments.filter(x =>
          this.categoryFilter.find(y => +y === +x.categoryId)
        ));

      }

      if (result.length > 0) {
        const final = [];
        //combine result into one final array
        result.forEach(function (val) {
          final.push(val);
        });
        //remove duplicates from final array
        const unique = final.filter(function (elem, index, self) {
          return index === self.indexOf(elem);
        });

        this.Documents$ = unique[0];
      }
    }

    if (this.Documents$.length == 0) {
      this.Documents$ = null;
      this.collectionSize = 0;
    }
    else {
      this.collectionSize = this.Documents$.length;
    }
  }

  showCategories() {
    $("#pnlCategories").show();
    $("#pnlDocuments").hide();

    this.router.navigate([], {
      queryParams: {
        id: null
      },
      queryParamsHandling: "merge"
    })

  }

  highlightCategory(paramName, categoryName) {
    this.route.queryParams.subscribe((params) => {
      const annualReportParam = params[paramName];
      if (annualReportParam === '1') {
        console.log('show annual report');
        const annualReportItem = this.DocumentCategories$.find(x => x.title === categoryName);
        console.log('Cat: ' + annualReportItem);
        if (annualReportItem !== null) {
          //this.selectAnnualReport = true;
          this.selectedCategoryId = annualReportItem.id;
          //console.log(this.selectedCategoryId);
          const exists = this.categoryFilter.some(f => f === annualReportItem.id.toString());
          if (exists === false) {
            this.categoryFilter.push(annualReportItem.id.toString());
          }
          this.applyFiltersNew();
        }
      }
    });
  }

  highlightCategoryId(paramName) {
    //console.log("In highlight category - " + paramName);
    this.route.queryParams.subscribe((params) => {
      const folderParam = params[paramName];
      //console.log(folderParam);
      if (folderParam !== null) {
        const annualReportItem = this.DocumentCategories$.find(x => x.id === parseInt(folderParam));
        //console.log(annualReportItem);
        if (annualReportItem !== null) {
          //this.selectAnnualReport = true;
          this.selectedCategoryId = annualReportItem.id;
          //console.log(this.selectedCategoryId);
          const exists = this.categoryFilter.some(f => f === annualReportItem.id.toString());
          if (exists === false) {
            this.categoryFilter.push(annualReportItem.id.toString());
          }
          this.applyFilters();
        }
      }
    });
  }

  ngAfterContentInit() {
    this.getDocumentCategoriesList();
    this.getDocumentsList();
  }

  ngOnInit() {

    this.titleService.setTitle("Document Library | COEGA");
    $("#pnlDocuments").hide();
  }

  getCategoryTitle() {
    if (this.selectedCategoryId > 0) {
      const Item = this.DocumentCategories$.find(x => x.id === this.selectedCategoryId);
      return Item.title;
    }
    else
      return "All categories";
  }

}
